var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('MarketingLoading'):(_vm.marketing)?_c('BoxContainer',{attrs:{"htmlContent":_vm.marketing.content}}):_c('FeedbackUser',{attrs:{"text":"Não foi possível carregar as informações adicionais do plano."}})}
var staticRenderFns = []

export { render, staticRenderFns }